// extracted by mini-css-extract-plugin
module.exports = {"title":"title-2-foq","number":"number-1ZlLf","text":"text-2fWHN","cities":"cities-2TU_0"};